module.exports = __webpack_public_path__ + "img/state-farm-logo.b97c3819.png";